/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class AccordionTab extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.button = this.querySelector('.accordion__toggle');
    this.panel = this.querySelector('.accordion__panel');
    this.content = this.querySelector('.accordion__content');
    this.isLegacy = !!this.details;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    if (typeof theme !== 'undefined' && theme.initWhenVisible) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 200
      });
    } else {
      this.init();
    }
  }
  init() {
    if (this.isLegacy) {
      if (this.summary) this.summary.addEventListener('click', e => this.onClickLegacy(e));
    } else {
      if (this.button) this.button.addEventListener('click', e => this.onClickModern(e));
    }
  }
  onClickLegacy(e) {
    e.preventDefault();
    this.details.style.overflow = 'hidden';
    if (this.isClosing || !this.details.open) {
      this.openLegacy();
    } else if (this.isExpanding || this.details.open) {
      this.shrinkLegacy();
    }
  }
  closeOthers() {
    const groupRoot = this.closest('[data-accordion-group]') || document;
    const others = groupRoot.querySelectorAll('accordion-tab');
    const beforeTop = this.getBoundingClientRect().top;
    others.forEach(tab => {
      if (tab !== this) {
        if (tab.isLegacy && tab.details?.open) {
          if (tab.animation) tab.animation.cancel();
          tab.details.open = false;
          tab.summary.setAttribute('aria-expanded', 'false');
          tab.details.style.height = '';
          tab.details.style.overflow = '';
        } else if (!tab.isLegacy && tab.button && tab.button.getAttribute('aria-expanded') === 'true') {
          if (tab.animation) tab.animation.cancel();
          tab.button.setAttribute('aria-expanded', 'false');
          tab.panel.setAttribute('hidden', '');
          tab.panel.style.height = '';
        }
        tab.animation = null;
        tab.isClosing = false;
        tab.isExpanding = false;
      }
    });
    const afterTop = this.getBoundingClientRect().top;
    const shift = afterTop - beforeTop;
    if (shift !== 0) {
      window.scrollBy(0, shift);
    }
  }
  shrinkLegacy() {
    this.isClosing = true;
    this.summary.setAttribute('aria-expanded', 'false');
    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)}px`;
    this.animateTab(this.details, startHeight, endHeight, false);
  }
  openLegacy() {
    this.closeOthers();
    this.summary.setAttribute('aria-expanded', 'true');
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expandLegacy());
  }
  expandLegacy() {
    this.isExpanding = true;
    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop) + this.content.offsetHeight}px`;
    this.animateTab(this.details, startHeight, endHeight, true);
  }
  onClickModern(e) {
    e.preventDefault();
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    if (this.isClosing || !isOpen) {
      this.openModern();
    } else if (this.isExpanding || isOpen) {
      this.shrinkModern();
    }
  }
  openModern() {
    this.closeOthers();
    this.button.setAttribute('aria-expanded', 'true');
    this.panel.removeAttribute('hidden');
    window.requestAnimationFrame(() => {
      this.isExpanding = true;
      const startHeight = '0px';
      const endHeight = `${this.panel.scrollHeight}px`;
      this.animateTab(this.panel, startHeight, endHeight, true);
    });
  }
  shrinkModern() {
    this.isClosing = true;
    this.button.setAttribute('aria-expanded', 'false');
    const startHeight = `${this.panel.scrollHeight}px`;
    const endHeight = '0px';
    this.animateTab(this.panel, startHeight, endHeight, false);
  }
  animateTab(element, start, end, isOpen) {
    if (this.animation) this.animation.cancel();
    this.animation = element.animate({
      height: [start, end]
    }, {
      duration: isOpen ? 400 : 300,
      easing: isOpen ? 'ease-out' : 'ease-in'
    });
    this.animation.onfinish = () => this.onAnimationFinish(isOpen);
    this.animation.oncancel = () => {
      this.isClosing = false;
      this.isExpanding = false;
    };
  }
  onAnimationFinish(isOpen) {
    if (this.isLegacy) {
      this.details.open = isOpen;
      this.summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      this.details.style.height = this.details.style.overflow = '';
    } else {
      this.button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (!isOpen) {
        this.panel.setAttribute('hidden', '');
      } else {
        this.panel.style.height = 'auto';
      }
    }
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
  }
}
if (!customElements.get('accordion-tab')) {
  customElements.define('accordion-tab', AccordionTab);
}
/******/ })()
;